export default {
    cardBox: {
        marginTop: "40px",
    },
    bankName: {
        margin: "0"
    },
    cardInformation: {
        display: "flex",
        columnGap: "10px",
        justifyContent: "center",
        alignItems: "center"
    },
    cardText: {
        fontSize: "14px"
    },
    pointer: {
        cursor: "pointer"
    },
}